import React, { useEffect, useState } from "react";
import salonService from "../../services/SalonService";
import "./MyMemberships.css";
import { useSalon } from "../../context/SalonContext";
import GlobalLoader from "../loadingIndicator/GlobalLoader";
import {
    FaCrown, FaCheckCircle, FaCalendarAlt, FaClock,
    FaGift, FaPercentage, FaStore, FaChevronRight,
    FaInfoCircle, FaHourglassHalf
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function MyMemberships() {
    const { salonUuid, customerId, setMembershipCount, salonName } = useSalon();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                let mySalonUuid = salonUuid ? salonUuid : localStorage.getItem("SALON_UUID");
                const response = await salonService.getCustomerMemberships(mySalonUuid, customerId);
                if (response.status === 200) {
                    setPlans(response.data);
                    setMembershipCount(response.data.length);
                }
            } catch (error) {
                console.error("Failed to fetch memberships", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPlans();
    }, []);

    if (loading) return <GlobalLoader />;

    return (
        <div className="my-memberships-page">
            <div className="membership-content-container py-4">
                {plans.length === 0 ? (
                    <div className="empty-state-memberships">
                        <div className="empty-icon">💎</div>
                        <h3>No Active Memberships</h3>
                        <p>Unlock exclusive benefits and discounts by joining our membership program.</p>
                        <button
                            className="premium-action-btn primary mt-4"
                            onClick={() => navigate('/membership-plans')}
                        >
                            Explore Plans
                        </button>
                    </div>
                ) : (
                    <div className="plans-grid-premium">
                        {plans.map((plan) => {
                            const isActive = plan.status === 'ACTIVE';
                            const isVerified = plan.verifiedByOwner;

                            return (
                                <div
                                    className={`premium-plan-card ${!isActive ? "expired-plan-card" : ""}`}
                                    key={plan.id}
                                >
                                    <div className="plan-header-premium">
                                        <div className="plan-status-badge">
                                            <span className={`status-pill ${plan.status.toLowerCase()}`}>
                                                {isActive ? <FaCheckCircle className="me-1" /> : <FaInfoCircle className="me-1" />}
                                                {plan.status}
                                            </span>
                                        </div>
                                        <div className="plan-icon-wrapper">
                                            <FaCrown className="crown-icon" />
                                        </div>
                                        <h3 className="plan-name-text">{plan.name}</h3>
                                        <div className="salon-info-tag">
                                            <FaStore className="me-1" /> {plan.salonName}
                                        </div>
                                    </div>

                                    <div className="plan-pricing-section">
                                        <div className="price-box">
                                            <span className="currency">₹</span>
                                            <span className="amount">{plan.price}</span>
                                        </div>
                                        <div className="validity-tag">
                                            <FaCalendarAlt className="me-1" />
                                            {new Date(plan.validTill).toLocaleDateString("en-IN", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                            })}
                                        </div>
                                    </div>

                                    <div className="verification-info-box">
                                        {!isVerified ? (
                                            <div className="status-message pending">
                                                <FaHourglassHalf className="me-2" /> Pending salon approval
                                            </div>
                                        ) : (
                                            <div className="status-message verified">
                                                <FaCheckCircle className="me-2" /> Verified Membership
                                            </div>
                                        )}

                                        {isActive && plan.remainingDays !== undefined && (
                                            <div className="remaining-tag">
                                                <FaClock className="me-1" /> {plan.remainingDays} days left
                                            </div>
                                        )}
                                    </div>

                                    <div className="premium-plan-benefits">
                                        <h4 className="benefits-title">Your Benefits</h4>
                                        <ul className="benefits-list-modern">
                                            {plan.benefits.map((benefit, idx) => {
                                                let icon = <FaCheckCircle className="text-success" />;
                                                if (/free/i.test(benefit)) icon = <FaGift className="text-warning" />;
                                                else if (/discount/i.test(benefit)) icon = <FaPercentage className="text-primary" />;

                                                return (
                                                    <li key={idx} className="benefit-item-modern">
                                                        <span className="benefit-icon-modern">{icon}</span>
                                                        <span className="benefit-text-modern">{benefit}</span>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>

                                    <div className="plan-footer-premium">
                                        <button
                                            className="buy-now-btn-premium"
                                            onClick={() => navigate('/booking')}
                                        >
                                            Use Benefits Now <FaChevronRight className="ms-2" />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
